<template src="./add-vertical.component.html"></template>
<style scoped src="./add-vertical.component.css"></style>
<script lang="ts">
import Vue from 'vue';
import Sidebar from '@/components/sidebar/sidebar.component.vue';
import api from '@/api';

export default Vue.extend({
  data() {
    return {
      msg: 'Add Vertical',
      hidden: true,
      name: '',
      errorMessage: '',
    };
  },
  mounted() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  destroyed() {
    document.body.classList.add(
      'min-w-site',
      'bg-40',
      'text-90',
      'font-medium',
      'min-h-full',
    );
  },
  components: {
    Sidebar,
  },
  methods: {
    async addVertical() {
      const response = await api.execute('post', '/verticals', {
        name: this.name,
      }).catch(err => {
        console.log(err.response);
        if (err.response.status === 500) {
          this.hidden = false;
          this.errorMessage = err.response.data.error;
        }
      });

      if (response) {
        this.hidden = true;
        alert('Vertical added correctly.');
        this.name = '';
      }
    },
  },
});
</script>
